import styles from "./Details.module.css";
import { Input } from "../../../common/Input";
import { useForm } from "react-hook-form";
import { ButtonFooter } from "../../../common/ButtonFooter";
import { useState } from "react";
import { PayWithButton } from "../../../common/PayWithButton";
import { CustomPhoneInput } from "../../../common/PhoneInput";

export const Details = ({
  onContinue,
  defaultName,
  defaultPhone,
  isLoading,
}: {
  onContinue: () => void;
  defaultName: string;
  defaultPhone?: string;
  isLoading?: boolean;
}) => {
  const { handleSubmit, control, register } = useForm();
  const [fullName, setFullName] = useState(defaultName);
  const [phoneVal, setPhoneVal] = useState(defaultPhone);

  return (
    <div className={styles.container}>
      <form onSubmit={handleSubmit(onContinue)}>
        <div className={styles.inputs}>
          <Input
            register={register}
            value={fullName}
            onChange={(e: any) => setFullName(e.target.value)}
            inputId="fullname"
            type="text"
            label="Full name"
            placeholder=""
            // required
          />

          <CustomPhoneInput
            register={register}
            inputId="phone"
            type="text"
            // labelfocus="Phone number"
            placeholder=""
            label="Phone number"
            control={control}
            value={phoneVal}
            setVal={setPhoneVal}
            required
          />
        </div>
        <ButtonFooter showNote>
          <PayWithButton
            isLoading={isLoading}
            isDisabled={!fullName?.length || !phoneVal?.length}
          />
        </ButtonFooter>
      </form>
    </div>
  );
};
